var map = {
	"./Modulo 1/AUDIO 01.mp3": "b274",
	"./Modulo 1/AUDIO 02.mp3": "4331",
	"./Modulo 1/AUDIO 03.mp3": "50de",
	"./Modulo 1/AUDIO 04.mp3": "e124",
	"./Modulo 1/AUDIO 05.mp3": "ea49",
	"./Modulo 1/AUDIO 06.mp3": "1f14",
	"./Modulo 1/AUDIO 07.mp3": "730a",
	"./Modulo 1/AUDIO 08.mp3": "c551",
	"./Modulo 1/AUDIO 09.mp3": "8d51",
	"./Modulo 1/AUDIO 10.mp3": "a459",
	"./Modulo 1/AUDIO 11.mp3": "db0e",
	"./Modulo 1/AUDIO 12.mp3": "aee2",
	"./Modulo 1/AUDIO 13.1.mp3": "b3fa",
	"./Modulo 1/AUDIO 13.2.mp3": "2ca1",
	"./Modulo 1/AUDIO 14.mp3": "645d",
	"./Modulo 1/AUDIO 15.1.mp3": "071e",
	"./Modulo 1/AUDIO 15.mp3": "4252",
	"./Modulo 1/AUDIO 16.mp3": "48cc",
	"./Modulo 2/AUDIO 01.mp3": "1e92",
	"./Modulo 2/AUDIO 02.mp3": "e952",
	"./Modulo 2/AUDIO 03.mp3": "4476",
	"./Modulo 2/AUDIO 04.mp3": "bcb5",
	"./Modulo 2/AUDIO 05.mp3": "e04f",
	"./Modulo 2/AUDIO 06.mp3": "4b11",
	"./Modulo 2/AUDIO 07.mp3": "a283",
	"./Modulo 2/AUDIO 08.mp3": "8510",
	"./Modulo 2/AUDIO 09.mp3": "03f7",
	"./Modulo 2/AUDIO 10.mp3": "cef5",
	"./Modulo 2/AUDIO 11.mp3": "d273",
	"./Modulo 2/AUDIO 12.mp3": "9a4d",
	"./Modulo 2/AUDIO 13.mp3": "25ca",
	"./Modulo 2/AUDIO 14.mp3": "adc5",
	"./Modulo 2/AUDIO 15.mp3": "c6da",
	"./Modulo 2/AUDIO 16.mp3": "7d32",
	"./Modulo 2/AUDIO 17.mp3": "cd73",
	"./Modulo 2/AUDIO 9-2.mp3": "9c0b",
	"./Modulo 3/AUDIO 01.mp3": "3b37",
	"./Modulo 3/AUDIO 02.mp3": "140c",
	"./Modulo 3/AUDIO 03.mp3": "4c02",
	"./Modulo 3/AUDIO 04.mp3": "dace",
	"./Modulo 3/AUDIO 05.mp3": "152a",
	"./Modulo 3/AUDIO 06.mp3": "7abf",
	"./Modulo 3/AUDIO 07.mp3": "bc23",
	"./Modulo 3/AUDIO 08.mp3": "edf5",
	"./Modulo 3/AUDIO 09.mp3": "5d2b",
	"./Modulo 3/AUDIO 10.mp3": "4ea5",
	"./Modulo 3/AUDIO 11.mp3": "499a",
	"./Modulo 3/AUDIO 12.mp3": "7d3f",
	"./Modulo 3/AUDIO 13.mp3": "9043",
	"./Modulo 3/AUDIO 14.mp3": "eb06",
	"./Modulo 3/AUDIO 15.mp3": "5de7",
	"./Modulo 3/AUDIO 16.mp3": "dd48",
	"./Modulo 3/AUDIO 17.mp3": "334a",
	"./Modulo 3/AUDIO 18.mp3": "fa0d",
	"./Modulo 3/AUDIO 19.mp3": "eb33",
	"./Modulo 3/AUDIO 20.mp3": "0fcc",
	"./Modulo 3/AUDIO 21.mp3": "392d",
	"./Modulo 3/AUDIO 22.mp3": "dadd",
	"./Presentacion/AUDIO 01.mp3": "afde",
	"./Presentacion/AUDIO 02.mp3": "9847",
	"./Presentacion/AUDIO 03.mp3": "fa90",
	"./Presentacion/AUDIO 04.mp3": "832a",
	"./Presentacion/AUDIO 05.mp3": "eaa1",
	"./Presentacion/AUDIO 06.mp3": "e3c3",
	"./Presentacion/AUDIO 07.mp3": "dd92",
	"./Presentacion/AUDIO 08.mp3": "a500",
	"./Presentacion/AUDIO 09.mp3": "e5ef",
	"./Presentacion/AUDIO 10.mp3": "490a",
	"./Presentacion/AUDIO 11.mp3": "d21a",
	"./Presentacion/AUDIO 12.mp3": "acd7",
	"./Presentacion/AUDIO 13.mp3": "fe23",
	"./Presentacion/AUDIO 14.mp3": "4ed4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d75d";